import {Component, Input, OnInit} from '@angular/core';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {BehaviorSubject, Subscription, timer} from 'rxjs';
import {concatMap, distinctUntilChanged, expand, filter, tap} from 'rxjs/operators';
import {UnitPricePlansService} from './unit-price-plans.service';
import {EndUserPricePlanModel} from '../end-user-price-plan-card/end-user-price-plan.model';

@Component({
  selector: 'app-unit-price-plans',
  templateUrl: './unit-price-plans.component.html',
})
export class UnitPricePlansComponent implements OnInit {
  @Input() unitId: BehaviorSubject<number>;
  refreshInterval = 120000;
  pricePlans: BehaviorSubject<Array<EndUserPricePlanModel>> = new BehaviorSubject([]);
  pollDataSubscription: Subscription;
  subscriptions: Subscription[] = [];

  swiperConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
  };
  constructor(
    private unitPricePlanService: UnitPricePlansService,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.unitId
        .pipe(
          distinctUntilChanged(),
          filter(i => i !== null)
        ).subscribe(unitId => {
        this.stopRefresh();
        this.startRefresh(unitId);
      })
    );
  }


  startRefresh(unitId: number) {
    const pollDataObservable = this.unitPricePlanService.getUnitPricePlans(unitId).pipe(
      tap(pricePlans => this.pricePlans.next(pricePlans))
    );
    this.pollDataSubscription = pollDataObservable.pipe(
      expand(() =>
        timer(this.refreshInterval)
          .pipe(concatMap(() => pollDataObservable))
      )
    ).subscribe();
  }


  stopRefresh() {
    if (this.pollDataSubscription) {
      this.pollDataSubscription.unsubscribe();
    }
  }
}
